export default __webpack_public_path__ + "static/media/Page19.c20cc915.txt";